import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
// const links = {
//   bhaktapur_ddc: {
//     service:'http://ddcbhaktapur.gov.np/',
//     service_text:'ddcbhaktapur.gov.np',
//     notice:'http://ddcbhaktapur.gov.np/news-type/ne-news-and-notices/',
//     notice_text:'ddcbhaktapur.gov.np/news-type/ne-news-and-notices',
//   },
//   changunarayan_municipality: {
//     service:'http://changunarayanmun.gov.np/ne/services',
//     service_text:'changunarayanmun.gov.np/ne/services',
//     notice:'http://changunarayanmun.gov.np/ne/news-notices',
//     notice_text:'changunarayanmun.gov.np/ne/news-notices',
//   },
//   bhaktapur_municipality: {
//     service:'http://bhaktapurmun.gov.np/ne/services',
//     service_text:'bhaktapurmun.gov.np/ne/services',
//     notice:'http://bhaktapurmun.gov.np/ne/news-notices',
//     notice_text:'bhaktapurmun.gov.np/ne/news-notices',
//   },
//   madhyapur_thimi_municipality: {
//     service:'http://madhyapurthimimun.gov.np/ne/services',
//     service_text:'madhyapurthimimun.gov.np/ne/services',
//     notice:'http://madhyapurthimimun.gov.np/ne/news-and-notices',
//     notice_text:'madhyapurthimimun.gov.np/ne/news-and-notices',
//   },
//   suryabinayak_municipality: {
//     service:'http://www.suryabinayakmun.gov.np/ne/services',
//     service_text:'www.suryabinayakmun.gov.np/ne/services',
//     notice:'http://www.suryabinayakmun.gov.np/ne/news-notices',
//     notice_text:'www.suryabinayakmun.gov.np/ne/news-notices',
//   },
// }

const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();
  var HtmlToReactParser = require('html-to-react').Parser;
  var htmlToReactParser = new HtmlToReactParser();

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>जानकारी</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>{props.title}</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          {props && props.data &&
            <GridContainer style={{margin: 'auto', marginTop: '50px', color: '#333',}} xs={12} sm={12} md={8}>
              <GridItem md={4} xs={8} sm={4}><a style={{ backgroundColor: '#fff', padding: '30px', fontSize: '18px', color: 'rgb(19, 76, 122)' }} href={props.data.link_for_related_document} target="_blank" >संबम्धित कागजात <OpenInNewIcon/></a></GridItem>
              <GridItem md={4} xs={8} sm={4}><a style={{ backgroundColor: '#fff', padding: '30px', fontSize: '18px', color: 'rgb(19, 76, 122)' }} href={props.data.link_for_services} target="_blank" >सेवाहरु <OpenInNewIcon/></a></GridItem>
              <GridItem md={4} xs={8} sm={4}><a style={{ backgroundColor: '#fff', padding: '30px', fontSize: '18px', color: 'rgb(19, 76, 122)' }} href={props.data.link_for_news_and_notices} target="_blank" >सूचना तथा समाचार <OpenInNewIcon/></a></GridItem>
            </GridContainer>
          }
        </GridItem>
      </GridContainer>
    </div>
  );
}
